const API_BASE = process.env.REACT_APP_API_BASE_URL || '';

/**
 * GET /esg-informativa/pdf-download?t=TOKEN
 * Returns the PDF as a Blob.
 */
export async function downloadPdf(token) {
    const res = await fetch(
        `${API_BASE}/esg-informativa/pdf-download?t=${encodeURIComponent(token)}`,
        {headers: {Accept: 'application/pdf'}}
    );

    if (!res.ok) throw new Error('network-error');

    const blob = await res.blob();
    if (blob.size === 0) throw new Error('network-error');

    const disposition = res.headers.get('Content-Disposition');
    let fileName = 'documento.pdf';
    if (disposition) {
        const match = disposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
        if (match?.[1]) fileName = match[1].replace(/['"]/g, '').trim();
    }

    return {blob, fileName};
}